import {
  PlatzNumberTokenView,
  PlatzWordTokenView,
  SourceLocation,
  OpenAiSourceLocation,
  SourceLocationType,
  YoutubeSourceLocation,
  GoogledLyricsSourceLocation,
  TextSourceLocation,
  PlatzTabTokenView,
  PlatzNewLineTokenView,
  PlatzPunctuationTokenView,
  PlatzBlobViewTokensItem,
  PlatzSpaceTokenView,
  ChatDetailsView,
  TextPageView,
  GoogledLyricsDetailsView,
  YouTubePageView,
} from "../api-generated";
import { SourceDetailsView } from "../shared";

type Token = PlatzBlobViewTokensItem;

export function isWordToken(token: Token): token is PlatzWordTokenView {
  return token.type === "word";
}

export function isNumberToken(token: Token): token is PlatzNumberTokenView {
  return token.type === "number";
}

export function isPunctuationToken(
  token: Token
): token is PlatzPunctuationTokenView {
  return token.type === "punctuation";
}

export function isNewLineToken(token: Token): token is PlatzNewLineTokenView {
  return token.type === "new_line";
}

export function isTabToken(token: Token): token is PlatzTabTokenView {
  return token.type === "tab";
}

export function isSpaceToken(token: Token): token is PlatzSpaceTokenView {
  return token.type === "space";
}

export function isString(thing: any): thing is string {
  return typeof thing === "string";
}

export function isWhitespace(str: string): boolean {
  return /^\s*$/.test(str);
}

export function isChatLocation(
  location: SourceLocation
): location is OpenAiSourceLocation {
  return location.type === SourceLocationType.openai_chat;
}

export function isYoutubeLocation(
  location: SourceLocation
): location is YoutubeSourceLocation {
  return location.type === SourceLocationType.youtube;
}

export function isLyricsLocation(
  location: SourceLocation
): location is GoogledLyricsSourceLocation {
  return location.type === SourceLocationType.googled_lyrics;
}

export function isTextLocation(
  location: SourceLocation
): location is TextSourceLocation {
  return location.type === SourceLocationType.text_page;
}

export function isOpenAiSource(
  sourceView: SourceDetailsView
): sourceView is ChatDetailsView {
  return sourceView.type === "openai_chat";
}

export function isTextSource(
  sourceView: SourceDetailsView
): sourceView is TextPageView {
  return sourceView.type === "text";
}

export function isYoutubeSource(
  sourceView: SourceDetailsView | unknown
): sourceView is YouTubePageView {
  return (sourceView as SourceDetailsView).type === "youtube_transcript";
}

export function isGoogledLyricsSource(
  sourceView: SourceDetailsView
): sourceView is GoogledLyricsDetailsView {
  return sourceView.type === "googled_lyrics";
}
